module.exports = __webpack_public_path__ + "static/media/arrows.f7ea8761.svg";